import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS, GRID_REFETCH_INTERVAL_MS } from "../constants";
import { usePollingGate } from "./usePollingGate";

/**
 * DBCO-0059 (N-10) - the delays of an operation. Refreshes about every 60 s while visible, but never while a drawer or a confirm
 * dialog holds the polling gate; a write refetches at once through its invalidation.
 */
export const useOperationDelays = (operationId: string) => {
  const { busy } = usePollingGate();
  return useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.delays(operationId),
    queryFn: () => drybulkCargoOperationsService.listDelays(operationId),
    enabled: Boolean(operationId),
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchInterval: busy ? false : GRID_REFETCH_INTERVAL_MS,
    refetchIntervalInBackground: false,
  });
};
